// eslint-disable-next-line import/prefer-default-export
export const getPillColor = days => {
  let pillColor = '';
  if (days <= -6) pillColor = 'secondary';
  else if (days > -6 && days <= 3) pillColor = 'danger';
  else if (days > 3 && days <= 7) pillColor = 'warning';
  else pillColor = 'success';
  return pillColor;
};
